<template>
  <div class="u-full-width u-pad-x-1of12 u-pad-y-lg u-pad-y-md--sm">
    <div class="list-items u-row u-radius u-bg-white u-pad-lg u-pad-x-md--sm u-between">
      <div
        v-for="(data, index) in data.items"
        :key="data.message"
        class="u-w4of10 u-w12of12--sm u-marg-b-lg"
      >
        <div class="list-items__circle u-bg-blue u-round" />
        <p class="t-text u-marg-t-sm u-blue">{{ data.title }}</p>
        <p class="t-text u-marg-t-sm">{{ data.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListItems',
  props: {
    data: {
      type: Object,
      required: true
    },
  },

  watch: {
  },

  data() {
    return {
    }
  },

  methods: {
  }
}
</script>

<style lang="stylus">
.list-items
  padding-bottom 0

  &__circle 
    height 40px
    width 40px
</style>